import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { breakpointCodes } from 'rp-mq-breakpoints';
import { connect } from 'react-redux';
import DataTable from './GridDataTable';
import tableConfig from '../config/statisticsSiresTable';
import {
    initialTableUpdate
} from '../helpers/dispatchProps';
import SalesHeader from '../components/DataTable/StatisticsSiresHeader';
import TableBody from '../components/DataTable/ExpandableRowsBody';
import SireStatsExpansion from '../components/DataTable/SireStatsExpansion';
import { expandRow } from '../actions/expandableRow';

const stateKey = 'statisticsSires';
const { EXTRA_NARROW, NARROW } = breakpointCodes;

/**
 * Container for statistics sales view
 */
class StatisticsSires extends Component {
    static colSpanGetter = (breakpoint) => {
        switch (breakpoint) {
            case EXTRA_NARROW:
            case NARROW:
                return 5;
            default:
                return 10;
        }
    };
    getTableProps() {
        return {
            headerComponent: SalesHeader,
            bodyComponent: TableBody,
            bodyProps: {
                expansionComponent: SireStatsExpansion,
                expandedRow: this.props.expandedRow,
                onRowExpand: this.props.onRowExpand,
                primaryColumn: 'sire_uid'
            }
        };
    }

    render() {
        return (
            <div className="table__StatisticsSires">
                <DataTable
                    config={tableConfig}
                    stateKey={stateKey}
                    errorMessage="No sires in our records for this sale"
                    colSpanGetter={StatisticsSires.colSpanGetter}
                    onMount={initialTableUpdate()}
                    tableProps={this.getTableProps()}
                />
            </div>
        );
    }
}

StatisticsSires.propTypes = {
    /**
     * Primary column value of expanded row
     * State prop
     */
    expandedRow: PropTypes.any,
    /**
     * Expandable row onRowExpand event handler
     * Dispatch prop
     */
    onRowExpand: PropTypes.func,
};


/**
 * Create component properties based on app state
 *
 * @param {{}} state App state
 * @returns {{}} Properties
 */
function mapStateToProps(state) {
    const expandedRow = _.get(state, `${stateKey}.expandableRow.expandedRow`);

    return {
        expandedRow,
    };
}

/**
 * Create component callable properties
 *
 * @returns {{}} Properties
 */
function mapDispatchToProps(dispatch) {
    return {
        onRowExpand(rowIndex) {
            dispatch(expandRow(stateKey, rowIndex, true));
        }
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(StatisticsSires);



// WEBPACK FOOTER //
// ./src/js/containers/StatisticsSires.js